const RETAIN_METHOD = Symbol.for('RemoteUi::Retain');
const RELEASE_METHOD = Symbol.for('RemoteUi::Release');
const RETAINED_BY = Symbol.for('RemoteUi::RetainedBy');

export { RELEASE_METHOD, RETAINED_BY, RETAIN_METHOD };
